import {Injectable} from "@angular/core";
import { Http } from "@angular/http";
import {ErrorInterceptor} from "./ErrorInterceptor";
import { Observable } from "rxjs";
import { map, catchError } from 'rxjs/operators';

declare let ENDPOINT_LUDYAPI: string;
declare let NAMESPACE_LUDYACCOUNT: string;

@Injectable()
export class PasswordRecoveryHttp {

    constructor(private http: Http, private errorInterceptor: ErrorInterceptor) {
    }

    sendToken(param: any): Observable<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "account/user/password/recovery/sendtoken";
        let request = this.http.put(url, param);

        return request.pipe(map(response => response.json()), catchError(this.errorInterceptor.handleErrorObs));
    }
    
    validateToken(param: any): Observable<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "account/user/password/recovery/validate";
        let request = this.http.put(url, param);

        return request.pipe(map(response => response.json()), catchError(this.errorInterceptor.handleErrorObs));
    }
    
    changePassword(param: any): Observable<any> {
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "account/user/password/recovery/change";
        let request = this.http.put(url, param);

        return request.pipe(map(response => response.json()), catchError(this.errorInterceptor.handleErrorObs));
    }
}
